import { createValidationDataObject } from "@/utils/form-validation";

export const webPaymentPlanValidator = {
  plan_id: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Plan is required");
    }

    return createValidationDataObject();
  },
};
